function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "fill",
  d: "M163.609-50.585A7.82,7.82,0,0,0,157.089-54a7.82,7.82,0,0,0-6.519,3.415,7.931,7.931,0,0,0-.923,7.308,6.246,6.246,0,0,0,1.151,1.9l5.769,6.776a.686.686,0,0,0,.523.242.686.686,0,0,0,.523-.242l5.767-6.774a6.252,6.252,0,0,0,1.151-1.9A7.933,7.933,0,0,0,163.609-50.585Z",
  transform: "translate(-149.144 54)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.1 4.075)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M259.858,52.219a3.846,3.846,0,1,0,3.846,3.846A3.85,3.85,0,0,0,259.858,52.219Zm0,6.318a2.472,2.472,0,1,1,2.472-2.472A2.475,2.475,0,0,1,259.858,58.537Z",
  transform: "translate(-256.012 -52.219)",
  fill: "#85cb3f"
}))))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34 6.927)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "fill",
  d: "M159.98-51.442A5.858,5.858,0,0,0,155.1-54a5.858,5.858,0,0,0-4.884,2.558,5.942,5.942,0,0,0-.692,5.475,4.679,4.679,0,0,0,.862,1.424l4.322,5.076a.514.514,0,0,0,.392.181.514.514,0,0,0,.392-.181l4.32-5.075a4.684,4.684,0,0,0,.862-1.422A5.943,5.943,0,0,0,159.98-51.442Z",
  transform: "translate(-149.144 54)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.107 2.395)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M259.858,52.219a3.846,3.846,0,1,0,3.846,3.846A3.85,3.85,0,0,0,259.858,52.219Zm0,6.318a2.472,2.472,0,1,1,2.472-2.472A2.475,2.475,0,0,1,259.858,58.537Z",
  transform: "translate(-256.012 -52.219)",
  fill: "#85cb3f"
}))))), /*#__PURE__*/React.createElement("path", {
  className: "stroke",
  d: "M3286.892,875.692s-2.069,4.095,3.593,3.442,8.275-6.206,13.719-4.9,14.59,7.077,19.381,3.593",
  transform: "translate(-3280.549 -854.962)",
  fill: "none",
  stroke: "#f9f9f9",
  strokeLinecap: "round",
  strokeWidth: 1
}));

var SvgRoute = function SvgRoute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "route",
    className: "fill-stroke",
    width: 45.904,
    height: 24.744,
    viewBox: "0 0 45.904 24.744",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/route.58e7238a.svg";
export { ForwardRef as ReactComponent };